import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useSelectedCamera from 'camera-module/camera/core/useSelectedCamera'
import useFilters from 'photo-module/filters/core/useFilters'
import useFiltersActions from 'photo-module/filters/core/useFiltersActions'
import { getPhotos } from 'photo-module/photos/core/photosActions'

/**
 * Custom hook to initialize gallery photos when accessing photo viewer routes directly
 * This ensures that photo navigation, tags, and gallery state are available on page refresh
 */
const useGalleryInitializer = () => {
  const dispatch = useDispatch()
  const selectedCamera = useSelectedCamera()
  const filters = useFilters()
  const filtersActions = useFiltersActions()
  const galleryPhotos = useSelector(state => state.galleryPhoto?.photos || [])
  const shared = JSON.parse(localStorage.getItem('isShared'))

  useEffect(() => {
    // Only load gallery if we have a camera but no photos loaded
    if (selectedCamera && galleryPhotos.length === 0) {
      // Ensure camera filter is set to current camera
      if (filters.cameras.length === 0 || !filters.cameras.includes(selectedCamera.id)) {
        filtersActions.setCamerasFilter([selectedCamera.id])
      }

      // Load photos with current filters
      dispatch(getPhotos(filters, shared))
    }
  }, [selectedCamera, galleryPhotos.length, filters, shared, dispatch, filtersActions])
}

export default useGalleryInitializer
